import React from 'react'
import Grid from "@material-ui/core/Grid";
import { useStyle } from "./Style";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import Tooltip from '@mui/material/Tooltip';
import { getPartner } from '../../../../../lib/access.es6';
import { formatDateLocale } from '../../../../../lib/utils.es6';
import ClaimNotes from './ClaimNotes';
import { ClaimStatusEnum } from '../../../lib/enum';

const ClaimDetails = (props) => {

console.log("claim details props", props.claim);
    //hospital details 
    const claimant_full_name = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.claimant_full_name
    : 'N/A';

  const claimant_phone_number = props.claim.claim_details.claimant_msisdn
    ? props.claim.claim_details.claimant_msisdn
    : 'N/A';

  const claimant_id_number = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.claimant_id_number
    : 'N/A';

  const claimant_relationship_to_patient = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.claimant_relationship_to_patient
    : 'N/A';

  const patientAge = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.age
    : 'N/A';



  const admission_date = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.admission_date
    : 'N/A';

  const discharge_date = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.discharge_date
    : 'N/A';

  const number_of_days_in_hospital = props.claim.claim_details.additional_details
    ? props.claim.claim_details.additional_details.number_of_days_in_hospital
    : 'N/A';



  const currencyCode = getPartner().country.currency_code



  const classes = useStyle();

  if (!props.claim.claim_details) {
    return <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} className={classes.claimwrapper}>
        <Grid container spacing={2} className={classes.claimdetailswrapper}>
          <Grid item xs={12} sm={12} md={12} className={classes.ClaimDetailscontent}>
            <p style={{ textAlign: 'center' }}>No details found</p>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  }




  return (
    <>
      {
        props.isLegalClaim(props.claim)  || props.isBDFandPrisonsClaim(props.claim) ? (<>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} className={classes.claimwrapper}>
              <Grid container spacing={2} className={classes.claimdetailswrapper}>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                  <h4>Policy Number</h4>
                  <p>{props.claim.claim_details.policy_number || "N/A"}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent} >
                  <h4>Policy Holder Full Names</h4>
                  <p>{props.claim.claim_details.policy_holder_fullname || "N/A"}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                  <h4>Policy Holder Phone Number </h4>
                  <p>{props.claim.claim_details.policy_holder_msisdn || "N/A"}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                  <h4>Agent Name</h4>
                  <p>{props.claim.web_agent_name || "N/A"}</p>
                </Grid>
                <div className={classes.borderbottom}></div>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                  <h4>Type of Legal Issue</h4>
                  <p>{props.claim.claim_details.additional_details.nature_of_case || "N/A"}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                  <h4>Type of Dispute</h4>
                  <p>{props.claim.claim_details.additional_details.type_of_dispute || "N/A"}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                  <h4>Event Date</h4>
                  <p>{props.claim.event_date || "N/A"}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                  <h4>Initiator Fullname</h4>
                  <p>{props.claim.initiator_fullname || "N/A"}</p>
                </Grid>
                <div className={classes.borderbottom}></div>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                  <h4>Relationship To Policyholder</h4>
                  <p>{props.claim.claim_details.relationship_to_policyholder || "N/A"}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                  <h4>Case Description</h4>
                  <p>{props.claim.claim_details.additional_details.brief_description || "N/A"}</p>
                </Grid>
                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                  <h4>Created At</h4>
                  <p>{formatDateLocale(props.claim.created_at) || "N/A"}</p>
                </Grid>

                <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                  <h4>Benefit Amount </h4>
                  <p>{`${currencyCode} ${(props.claim.benefits[0].max_benefit_amount_in_cents / 100).toLocaleString()}` || "N/A"}</p>

                </Grid>

                <div className={classes.borderbottom}></div>
              </Grid>
              <Grid container spacing={2} className={classes.notesheader}>
                <Grid item xs={12} md={12} sm={12}>
                  <ul>
                    <li><h4>Claim Notes</h4></li>
                    <li >
                      <Tooltip title="Add claim Notes">
                        <AddCircleOutlineRoundedIcon style={{ cursor: "pointer" }} onClick={() => props.toggleClaimNotesDialog()} />
                      </Tooltip>
                    </li>
                  </ul>

                </Grid>
              </Grid>
              <Grid container spacing={2} className={classes.noteswrapper}>
                <Grid item xs={12} md={12} sm={12}>
                  <div className={classes.notesbox}>
                    <ClaimNotes {...props} />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className={classes.borderbottom} style={{
            marginTop: '-40px',
          }}></div>

          
            
                {props.claim.status === ClaimStatusEnum.Approved && (
                  <Grid container spacing={2} className={classes.notesheader}>
                  <Grid item xs={12} md={12} sm={12}>
              <ul>
                <li><h4>Assign  Lawyer</h4></li>
                  <li >
                    <Tooltip title="Assign lawyer">
                      <AddCircleOutlineRoundedIcon style={{ cursor: "pointer" }} onClick={() => props.toggleAssignLawyerDialog()} />
                    </Tooltip>
                  </li>
                    </ul>

            </Grid>
             <Grid container spacing={2} >
              <Grid item xs={12} md={8} sm={4}>
                <div className={classes.notesbox}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4} sm={4}>
                      <h3>Name</h3>
                      <p>{props.claim.claim_details.additional_details.lawyer_name || "N/A"}</p>
                    </Grid>
                    <Grid item xs={12} md={4} sm={4}>
                      <h3>Email</h3>
                      <p>{props.claim.claim_details.additional_details.lawyer_email || "N/A"}</p>
                    </Grid>
                    <Grid item xs={12} md={4} sm={4}>
                      <h3>Phone Number</h3>
                      <p>{props.claim.claim_details.additional_details.lawyer_phone_number || "N/A"}</p>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Grid>
                )}
            

           

        </>) : 
        
        props.isMedicalCashClaim(props.claim) ? (<>
        
          <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} className={classes.claimwrapper}>
                <Grid container spacing={2} className={classes.claimdetailswrapper}>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent} >
                    <h4>Policy Holder Full Names</h4>
                    <p>{props.claim.claim_details.policy_holder_fullname || "N/A"}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Policy Holder  Number</h4>
                    <p>{props.claim.claim_details.policy_holder_msisdn || "N/A"}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Claimant Full Name</h4>
                    <p>{claimant_full_name}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                    <h4>Claimant Phone Number</h4>
                    <p>{claimant_phone_number}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Claimant ID Number</h4>
                    <p>{claimant_id_number}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Claimant Relationship To Patient</h4>
                    <p>{claimant_relationship_to_patient}</p>
                  </Grid>

                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Claimant Email</h4>
                    <p>{props.claim.claim_details.claimant_email || "N/A"}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                     <h4> Patient Full Name</h4>
                    <p>{props.claim.claim_details.dependant_fullname || "N/A"}</p>
                  </Grid>

                  <div className={classes.borderbottom}></div>

                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Patient National ID</h4>
                    <p>{props.claim.claim_details.dependant_national_id || "N/A"}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Patient Age</h4>
                    <p>{patientAge}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Relationship To Policyholder</h4>
                    <p>{props.claim.claim_details.relationship_to_policyholder || "N/A"}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                    <h4>Patient D.O.B</h4>
                    <p>{formatDateLocale(props.claim.claim_details.dependant_dob) || "N/A"}</p>
                  </Grid>
                  {/* <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                  <h4>Gender</h4>
                  <p>{props.claim.claim_details.gender || "N/A"}</p>
                </Grid> */}
                  <div className={classes.borderbottom}></div>


                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Discharge Date</h4>
                    <p>{formatDateLocale(discharge_date)}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Number Of Days In Hospital </h4>
                    <p>{number_of_days_in_hospital}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Hospital Attended</h4>
                    <p>{props.claim.claim_details.additional_details.hospital_attended || "N/A"}</p>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                    <h4>Cause Of Hospitilization</h4>
                    <p>{props.claim.claim_details.additional_details.cause_of_hospitilization || "N/A"}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>

                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Inpatient Number</h4>
                    <p>{props.claim.claim_details.additional_details.inpatient_number || "N/A"}</p>
                  </Grid>
                   <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Admission Date</h4>
                    <p>{formatDateLocale(admission_date)}</p>
                  </Grid>
              
                  <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                    <h4>Agent Name</h4>
                    <p>{props.claim.web_agent_name || "N/A"}</p>
                  </Grid>
                  {/* <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontentlast}>
                  <h4>Gender</h4>
                  <p>{props.claim.claim_details.gender || "N/A"}</p>
                </Grid> */}
                  <div className={classes.borderbottom}></div>

                </Grid>

                <Grid container spacing={2} className={classes.notesheader}>
                  <Grid item xs={12} md={12} sm={12}>
                    <ul>
                      <li><h4>Claim Notes</h4></li>
                      <li >
                        <Tooltip title="Add claim Notes">
                          <AddCircleOutlineRoundedIcon style={{ cursor: "pointer" }} onClick={() => props.toggleClaimNotesDialog()} />
                        </Tooltip>
                      </li>
                    </ul>

                  </Grid>
                </Grid>
                <Grid container spacing={2} className={classes.noteswrapper}>
                  <Grid item xs={12} md={12} sm={12}>
                    <div className={classes.notesbox}>
                      <ClaimNotes {...props} />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
        </>)
        : props.isAccidentalDeathClaim(props.claim) ? (<>
          
           <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.claimwrapper}
              >
                <Grid
                  container
                  spacing={2}
                  className={classes.claimdetailswrapper}
                >
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>{props.claim.claim_details.type_of_claim === "Accidental Death" ? "Deceased Names" : "Name of the Disabled"}</h4>
                    <p>
                      {props.claim.claim_details.dependant_fullname || "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Relation to Principal</h4>
                    <p>
                      {props.claim.claim_details.relationship_to_policyholder ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Gender</h4>
                    <p>{props.claim.claim_details.gender || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>{props.claim.claim_details.type_of_claim === "Accidental Death" ? "Deceased Date of Birth" : " Date of Birth of the Disabled"}</h4>
                    <p>
                      {formatDateLocale(
                        props.claim.claim_details.dependant_dob
                      ) || "N/A"}
                    </p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> {props.claim.claim_details.type_of_claim === "Accidental Death" ? "Deceased Date of Death" : "Date of Disability Event"}</h4>
                    <p>{formatDateLocale(props.claim.event_date) || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> {props.claim.claim_details.type_of_claim === "Accidental Death" ? "Deceased Age" : "Age of the Disabled"}</h4>
                    <p>
                      {props.claim.claim_details.additional_details.age ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>{props.claim.claim_details.type_of_claim === "Accidental Death" ? "Cause of Death" : "Type of Disability"}</h4>
                    <p>
                      {props.claim.claim_details.type_of_claim === "Accidental Death" ? props.claim.claim_details.additional_details.cause_of_death : props.claim.claim_details.additional_details.type_of_disability || "N/A"}
                       
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Benefit Amount </h4>
                    <p>
                      {`${currencyCode} ${(
                        props.claim.benefits[0].max_benefit_amount_in_cents /
                        100
                      ).toLocaleString()}` || "N/A"}
                    </p>
                  </Grid>

                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Full Name </h4>
                    <p>{props.claim.claim_details.additional_details.claimant_full_name || "N/A"}</p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant ID Number </h4>
                    <p>{props.claim.claim_details.additional_details.claimant_id_number || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Phone Number </h4>
                    <p>{props.claim.claim_details.claimant_msisdn || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Claimant Relationship </h4>
                    <p>{props.claim.claim_details.additional_details.claimant_relationship_to_patient || "N/A"}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Option </h4>
                    <p>
                      {
                        props.claim.claim_details.additional_details
                          .claimant_payment_option
                      }
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Details </h4>
                   
                    {props.claim.claim_details.additional_details
                      .claimant_payment_option === "Bank" ? (
                      <>
                        <p>
                          Bank Name:{" "}
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_name
                          }
                        </p>
                        <p>
                          Account Number:{" "}
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_account_number
                          }
                        </p>
                      </>
                    ) :(
                     <>
                        <p>
                          Mobile Money Number:{" "}
                          {
                            props.claim.claim_details.additional_details
                              .claimant_mobile_money_number
                          }
                        </p>

                        {props.claim.claim_details.additional_details.claimant_omang_number && (
                          <p>
                            Omang Number:{" "}
                            {
                              props.claim.claim_details.additional_details
                                .claimant_omang_number
                            }
                          </p>
                          )}
                      </>
                    )}
                  </Grid>
                    <Grid item xs={12} sm={3} md={3} className={classes.ClaimDetailscontent}>
                    <h4>Claimant Email</h4>
                    <p>{props.claim.claim_details.claimant_email || "N/A"}</p>
                  </Grid>       
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>{props.claim.claim_details.type_of_claim === "Accidental Death" ? "Funeral Home Name" : "Attending Physician"}</h4>
                    <p>{props.claim.claim_details.type_of_claim === "Accidental Death" ? props.claim.claim_details.additional_details.funeral_home_name || "N/A" : props.claim.claim_details.additional_details.attending_physician || "N/A"}</p>
                  </Grid>
                    <div className={classes.borderbottom}></div>
                  {props.claim.claim_details.type_of_claim === "Accidental Death" && (
                    <>
                     <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Death Certificate Number </h4>
                    <p>{props.claim.claim_details.additional_details.death_certficate_number || "N/A"}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                    </>
                  )}
                </Grid>
              </Grid>

              <Grid container spacing={2} className={classes.notesheader}>
                <Grid item xs={12} md={12} sm={12}>
                  <ul>
                    <li>
                      <h4>Claim Notes</h4>
                    </li>
                    <li>
                      <Tooltip title="Add claim Notes">
                        <AddCircleOutlineRoundedIcon
                          style={{ cursor: "pointer" }}
                          onClick={() => props.toggleClaimNotesDialog()}
                        />
                      </Tooltip>
                    </li>
                  </ul>
                </Grid>
              </Grid>
              <Grid container spacing={2} className={classes.noteswrapper}>
                <Grid item xs={12} md={12} sm={12}>
                  <div className={classes.notesbox}>
                    <ClaimNotes {...props} />
                  </div>
                </Grid>
              </Grid>
            </Grid>

        </>)  : props.isRoadsideAssistanceClaim(props.claim) ? (<>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.claimwrapper}
              >
                <Grid
                  container
                  spacing={2}
                  className={classes.claimdetailswrapper}
                >

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Car registration</h4>
                    <p>
                      {props.claim.claim_details.additional_details.car_registration ||
                        "N/A"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Assistance Type</h4>
                    <p>
                      {(() => {
                        const assistanceType = props.claim.claim_details.additional_details.assistance_type;
                        if (!assistanceType) return "N/A";
                        
                        if (Array.isArray(assistanceType)) {
                          return assistanceType.length > 0 
                            ? assistanceType.join(', ') 
                            : "N/A";
                        }
                        
                        return typeof assistanceType === 'string' 
                          ? assistanceType 
                          : "N/A";
                      })()}
                    </p>
                  </Grid>
                   <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Date of Incident/Accident</h4>
                    <p>{formatDateLocale(props.claim.event_date) || "N/A"}</p>
                  </Grid>
                   <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4> Incident Time</h4>
                    <p>{props.claim.claim_details.additional_details.incident_time || "N/A"}</p>
                  </Grid>  
                  <div className={classes.borderbottom}></div>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Full Name </h4>
                    <p>{props.claim.claim_details.additional_details.claimant_full_name || "N/A"}</p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant ID Number </h4>
                    <p>{props.claim.claim_details.additional_details.claimant_id_number || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Phone Number </h4>
                    <p>{props.claim.claim_details.claimant_msisdn || "N/A"}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Claimant Relationship </h4>
                    <p>{props.claim.claim_details.additional_details.claimant_relationship_to_patient || "N/A"}</p>
                  </Grid>
                  <div className={classes.borderbottom}></div>
                
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Option </h4>
                    <p>
                      {
                        props.claim.claim_details.additional_details
                          .claimant_payment_option
                      }
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Claimant Payment Details </h4>
                   
                    {props.claim.claim_details.additional_details
                      .claimant_payment_option === "Bank" ?  (
                      <>
                        <p>
                          Bank Name:{" "}
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_name
                          }
                        </p>
                        <p>
                          Account Number:{" "}
                          {
                            props.claim.claim_details.additional_details
                              .claimant_bank_account_number
                          }
                        </p>
                      </>
                    ) :
                    <>
                    <p>Payment Provider: {props.claim.claim_details.additional_details.claimant_payment_option || "N/A"}</p>
                    <p>Payment Provider Number: {props.claim.claim_details.additional_details.claimant_mobile_money_number || "N/A"}</p>
                    {props.claim.claim_details.additional_details.claimant_payment_option === "Smega" && (
                      <p>Omega Number: {props.claim.claim_details.additional_details.claimant_claimant_omang_number || "N/A"}</p>
                    )}
                    </> }
                  </Grid>
                   <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  > 

                    <h4>Claimant Bank Branch </h4>
                    <p>{props.claim.claim_details.additional_details.claimant_bank_branch || "N/A"}</p>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontentlast}
                  >
                    <h4>Claimant Email </h4>
                    <p>{props.claim.claim_details.claimant_email || "N/A"}</p>
                </Grid>
                <div className={classes.borderbottom}></div>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    className={classes.ClaimDetailscontent}
                  >
                    <h4>Distance Towed </h4>
                    <p>{props.claim.claim_details.additional_details.estimated_distance_towed || "N/A"}</p>
                  </Grid>

             <div className={classes.borderbottom}></div>
                </Grid>
              </Grid>

              <Grid container spacing={2} className={classes.notesheader}>
                <Grid item xs={12} md={12} sm={12}>
                  <ul>
                    <li>
                      <h4>Claim Notes</h4>
                    </li>
                    <li>
                      <Tooltip title="Add claim Notes">
                        <AddCircleOutlineRoundedIcon
                          style={{ cursor: "pointer" }}
                          onClick={() => props.toggleClaimNotesDialog()}
                        />
                      </Tooltip>
                    </li>
                  </ul>
                </Grid>
              </Grid>
              <Grid container spacing={2} className={classes.noteswrapper}>
                <Grid item xs={12} md={12} sm={12}>
                  <div className={classes.notesbox}>
                    <ClaimNotes {...props} />
                  </div>
                </Grid>
              </Grid>
            </Grid>
        </>) : (<>
          <p style={{ textAlign: 'center' }}>No details found</p>
        </>) 
      }
    </>
  )
}

export default ClaimDetails